// Uniform cascade positioning for the finished-run popups. Every card after the
// first overlaps the previous one by a fixed, tight step (down and slightly toward
// screen centre), newest frontmost — so cards overlap from the 2nd popup onward.
// Values are visual defaults, safe to tune.
export const BASE_TOP = 68; // just below the 60px site header
export const BASE_RIGHT = 16;
export const STEP_Y = 20; // vertical overlap step between consecutive cards
export const STEP_X = 12; // horizontal step toward centre between consecutive cards
export const BASE_Z = 1000;

export const positionFor = index => ({
  top: BASE_TOP + (index * STEP_Y),
  right: BASE_RIGHT + (index * STEP_X),
  zIndex: BASE_Z + index
});
